// ═══════════════════════════════════════════════
//   PROFILE — display, edit, icon picker, trait test
// ═══════════════════════════════════════════════

const {S, ALIENS, ALL_NICKS, TRAIT_QS, SFX, toast, scheduleSave, openWin, closeWin, earlyBadgeHTML} = window;

// ── Header color palettes ─────────────────
const _PALETTE_NAME_FILL = [
    {val:'', bg:'linear-gradient(135deg,#fff 50%,#ddd 50%)', label:'Default (white)'},
    {val:'#fde047', bg:'#fde047', label:'Yellow'},
    {val:'#7dd3fc', bg:'#7dd3fc', label:'Sky Blue'},
    {val:'#86efac', bg:'#86efac', label:'Mint'},
    {val:'#f72585', bg:'#f72585', label:'Hot Pink'},
    {val:'#c4b5fd', bg:'#c4b5fd', label:'Lavender'},
    {val:'#fdba74', bg:'#fdba74', label:'Peach'},
    {val:'#ffffff', bg:'#fff', label:'White'},
];
const _PALETTE_NAME_STROKE = [
    {val:'', bg:'linear-gradient(135deg,#f72585 50%,#ddd 50%)', label:'Default (hot pink)'},
    {val:'#1a0010', bg:'#1a0010', label:'Dark'},
    {val:'#7c3aed', bg:'#7c3aed', label:'Purple'},
    {val:'#0891b2', bg:'#0891b2', label:'Teal'},
    {val:'#f59e0b', bg:'#f59e0b', label:'Amber'},
    {val:'#16a34a', bg:'#16a34a', label:'Green'},
    {val:'#ffffff', bg:'#fff', label:'White'},
    {val:'#f97316', bg:'#f97316', label:'Orange'},
];
const _PALETTE_TAG_BG = [
    {val:'', bg:'repeating-linear-gradient(45deg,#f72585 0,#f72585 4px,#0891b2 4px,#0891b2 8px)', label:'Rarity default'},
    {val:'#f72585', bg:'#f72585', label:'Pink'},
    {val:'#0891b2', bg:'#0891b2', label:'Teal'},
    {val:'#7c3aed', bg:'#7c3aed', label:'Purple'},
    {val:'#fde047', bg:'#fde047', label:'Yellow'},
    {val:'#16a34a', bg:'#16a34a', label:'Green'},
    {val:'#f97316', bg:'#f97316', label:'Orange'},
    {val:'#1a0010', bg:'#1a0010', label:'Dark'},
];
const _PALETTE_HEADER_BG = [
    {val:'', bg:'linear-gradient(110deg,#fff8f0,#ffdcec,#ffe0ec)', label:'Default'},
    {val:'#ffdcec', bg:'#ffdcec', label:'Soft Pink'},
    {val:'#dbeafe', bg:'#dbeafe', label:'Sky Blue'},
    {val:'#ede9fe', bg:'#ede9fe', label:'Lavender'},
    {val:'#fef9c3', bg:'#fef9c3', label:'Yellow'},
    {val:'#dcfce7', bg:'#dcfce7', label:'Mint'},
    {val:'linear-gradient(110deg,#fce7f3,#e0f2fe)', bg:'linear-gradient(110deg,#fce7f3,#e0f2fe)', label:'Pink → Blue'},
    {val:'#ffedd5', bg:'#ffedd5', label:'Peach'},
    {val:'linear-gradient(110deg,#dcfce7,#fef9c3)', bg:'linear-gradient(110deg,#dcfce7,#fef9c3)', label:'Green → Yellow'},
    {val:'#1a0010', bg:'#1a0010', label:'Dark'},
];

let _pendingColors = null;

function _buildColorRow(rowId, palette, currentVal, key) {
    const cont = document.getElementById(rowId);
    if (!cont) return;
    cont.innerHTML = '';
    palette.forEach(({val, bg, label}) => {
        const s = document.createElement('div');
        s.className = 'prof-swatch' + (val === currentVal ? ' prof-swatch--active' : '');
        s.title = label;
        s.style.background = bg;
        s.addEventListener('click', () => {
            cont.querySelectorAll('.prof-swatch').forEach(x => x.classList.remove('prof-swatch--active'));
            s.classList.add('prof-swatch--active');
            if (_pendingColors) _pendingColors[key] = val;
            _epUpdatePreview();
        });
        cont.appendChild(s);
    });
}

// ══════════════════════════════════════════
// PROFILE + ICON PICKER + PNG SHARE
// ══════════════════════════════════════════
if (typeof window.profIconIdx === 'undefined') window.profIconIdx = 1;

let _iconIndices = [];

// Probe how many profile icons exist (up to 20), then render picker.
// containerId targets which grid element to populate ('inv-icon-grid' or 'edit-icon-grid').
function renderInvIcons(containerId) {
    const id = containerId || 'inv-icon-grid';
    const grid = document.getElementById(id);
    if (!grid) return;
    if (_iconIndices.length > 0) { buildIconGrid(_iconIndices, id); return; }
    grid.innerHTML = '';
    probeIcons(1, [], id);
}

function probeIcons(n, found, containerId) {
    if (n > 20) { _iconIndices = found; buildIconGrid(found, containerId); return; }
    const img = new Image();
    img.onload = () => { found.push(n); probeIcons(n + 1, found, containerId); };
    img.onerror = () => {
        if (found.length > 0 && n > found[found.length - 1] + 1) {
            _iconIndices = found; buildIconGrid(found, containerId);
        } else {
            probeIcons(n + 1, found, containerId);
        }
    };
    img.src = `assets/profile/profile_icon${n}.png?_=${Date.now()}`;
}

function buildIconGrid(indices, containerId) {
    const grid = document.getElementById(containerId || 'inv-icon-grid');
    if (!grid) return;
    if (indices.length === 0) {
        grid.innerHTML = '<div class="inv-empty">No profile icons found!<br>Add profile_icon1.png etc. to assets/profile/ ✦</div>';
        return;
    }
    grid.innerHTML = '';
    indices.forEach(i => {
        const d = document.createElement('div');
        d.className = 'inv-bg-item' + (window.profIconIdx === i ? ' active' : '');
        d.style.cssText = 'width:54px;height:54px;border-radius:50%;overflow:hidden;';
        d.innerHTML = `<img src="assets/profile/profile_icon${i}.png" alt="icon ${i}" style="width:100%;height:100%;object-fit:cover;"><div class="inv-bg-label">#${i}</div>`;
        d.addEventListener('click', () => setProfileIcon(i));
        grid.appendChild(d);
    });
}

function setProfileIcon(i) {
    window.profIconIdx = i;
    document.getElementById('prof-av-img').src = `assets/profile/profile_icon${i}.png`;
    buildIconGrid(_iconIndices, 'inv-icon-grid');
    buildIconGrid(_iconIndices, 'edit-icon-grid');
    _epUpdatePreview();
    buildIconGrid(_iconIndices, 'edit-icon-grid');
    toast(`Profile icon #${i} selected! ✦`);
    scheduleSave();
}

// ── Profile PNG share ──────────────────────
function _loadImg(src) {
    return new Promise((res, rej) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        const t = setTimeout(() => rej('timeout'), 3000);
        img.onload = () => {
            clearTimeout(t);
            res(img);
        };
        img.onerror = () => {
            clearTimeout(t);
            rej('err');
        };
        img.src = src + '?_=' + Date.now(); // bust cache for crossOrigin
    });
}

function _wrapText(cx, text, x, y, maxW, lineH, maxLines) {
    const words = text.replace(/<br\s*\/?>/gi, ' ').split(/\s+/);
    let line = '', drawn = 0;
    for (const w of words) {
        const test = line ? line + ' ' + w : w;
        if (cx.measureText(test).width > maxW && line) {
            cx.fillText(line, x, y + drawn * lineH);
            drawn++;
            if (drawn >= maxLines) {
                const ell = line + '…';
                cx.fillText(ell, x, y + (drawn - 1) * lineH);
                return;
            }
            line = w;
        } else line = test;
    }
    if (line) cx.fillText(line, x, y + drawn * lineH);
}

// Returns [r, g, b] from a #rrggbb / #rgb hex string, or null if unparseable.
function _hexToRgb(hex) {
    const m = /^#([0-9a-fA-F]{3,6})$/.exec(hex);
    if (!m) return null;
    let h = m[1];
    if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    return [parseInt(h.slice(0,2),16), parseInt(h.slice(2,4),16), parseInt(h.slice(4,6),16)];
}

// Returns true when the hex colour is light enough that dark text is needed.
function _isLightAccent(hex) {
    const rgb = _hexToRgb(hex);
    return rgb ? (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) > 160 : false;
}

// Converts a CSS background value (solid hex or linear-gradient string) into a
// canvas fillStyle. Falls back to the default warm-pink gradient when val is empty
// or unparseable.
function _parseBgForCanvas(cx, W, H, val) {
    const _defaultGrad = () => {
        const g = cx.createLinearGradient(0, 0, W, H);
        g.addColorStop(0, '#fff8f0');
        g.addColorStop(1, '#ffe0ec');
        return g;
    };
    if (!val) return _defaultGrad();
    if (/^#[0-9a-fA-F]{3,6}$/.test(val)) return val;
    // Extract all hex colours from linear-gradient(...)
    const colors = [...val.matchAll(/#[0-9a-fA-F]{3,6}/g)].map(m => m[0]);
    if (colors.length >= 2) {
        const g = cx.createLinearGradient(0, 0, W, H);
        colors.forEach((c, i) => g.addColorStop(i / (colors.length - 1), c));
        return g;
    }
    return _defaultGrad();
}

async function saveProfilePNG() {
    toast('Generating card… ⏳');
    await document.fonts.ready;
    const W = 600, H = 400;
    const cv = document.createElement('canvas');
    cv.width = W;
    cv.height = H;
    const cx = cv.getContext('2d');

    // Resolve user colour choices
    const hc = S.profileData.headerColors || {};
    const accent = hc.tagBg || '#f72585';
    const nameFill = hc.nameFill || 'white';
    const nameStroke = hc.nameStroke || '#f72585';
    const accentRgb = _hexToRgb(accent);
    const accentDot = accentRgb ? `rgba(${accentRgb},0.07)` : 'rgba(247,37,133,0.07)';
    const accentDiv = accentRgb ? `rgba(${accentRgb},0.3)` : 'rgba(247,37,133,0.3)';
    const lightAccent = _isLightAccent(accent);
    const accentText      = lightAccent ? '#1a0010'              : 'white';
    const accentTextFaint = lightAccent ? 'rgba(26,0,16,0.72)'  : 'rgba(255,255,255,0.72)';
    const accentTextMid   = lightAccent ? 'rgba(26,0,16,0.8)'   : 'rgba(255,255,255,0.8)';

    // Dark-bg detection: only #1a0010 in the header-bg palette is truly dark.
    const isDark = hc.headerBg === '#1a0010';
    const bodyText = isDark ? '#f0f0f0' : '#1a0010';
    const midText  = isDark ? '#ccc'    : '#666';

    // Card background
    cx.fillStyle = _parseBgForCanvas(cx, W, H, hc.headerBg || '');
    cx.fillRect(0, 0, W, H);

    // Dot texture
    cx.fillStyle = accentDot;
    for (let x = 0; x < W; x += 18) for (let y = 0; y < H; y += 18) {
        cx.beginPath();
        cx.arc(x, y, 1.5, 0, Math.PI * 2);
        cx.fill();
    }

    // Top bar
    cx.fillStyle = accent;
    cx.fillRect(0, 0, W, 58);
    cx.fillStyle = '#1a0010';
    cx.fillRect(0, 58, W, 3);
    cx.fillStyle = accentText;
    cx.textAlign = 'left';
    cx.textBaseline = 'alphabetic';
    cx.font = '12px "Press Start 2P"';
    cx.fillText('♡ KONBINI CLOWRI', 20, 36);
    cx.font = '6px "Press Start 2P"';
    cx.fillStyle = accentTextFaint;
    cx.fillText('LA MADRIGUERA  ·  MEMBER CARD', 20, 51);
    cx.textAlign = 'right';
    cx.fillStyle = accentTextMid;
    cx.font = '16px serif';
    cx.fillText('✦  ✧  ✦', W - 16, 40);
    cx.textAlign = 'left';

    // Avatar circle
    const avX = 74, avY = 138, avR = 46;
    cx.fillStyle = '#ffb3d1';
    cx.beginPath();
    cx.arc(avX, avY, avR, 0, Math.PI * 2);
    cx.fill();
    try {
        const img = await _loadImg(`assets/profile/profile_icon${window.profIconIdx}.png`);
        cx.save();
        cx.beginPath();
        cx.arc(avX, avY, avR, 0, Math.PI * 2);
        cx.clip();
        cx.drawImage(img, avX - avR, avY - avR, avR * 2, avR * 2);
        cx.restore();
    } catch {
        cx.font = '40px serif';
        cx.textAlign = 'center';
        cx.textBaseline = 'middle';
        cx.fillText('👾', avX, avY);
        cx.textAlign = 'left';
        cx.textBaseline = 'alphabetic';
    }
    cx.strokeStyle = '#1a0010';
    cx.lineWidth = 3;
    cx.beginPath();
    cx.arc(avX, avY, avR, 0, Math.PI * 2);
    cx.stroke();

    // Name — stroke drawn first to match CSS paint-order: stroke fill
    const nx = 148;
    const nameText = (S.profileData.name || 'USER').slice(0, 12);
    cx.save();
    cx.font = 'bold 20px "Press Start 2P"';
    cx.lineJoin = 'round';
    cx.lineWidth = 3;
    cx.strokeStyle = nameStroke;
    cx.strokeText(nameText, nx, 103);
    cx.fillStyle = nameFill;
    cx.fillText(nameText, nx, 103);
    cx.restore();

    // Subnick — use tag bg colour, else rarity colour, else accent
    const nick = ALL_NICKS.find(n => n.id === S.profileData.nick);
    if (nick) {
        const RARITY_COLORS = {common:'#f72585', uncommon:'#0891b2', rare:'#7c3aed', legendary:'#f59e0b'};
        cx.fillStyle = hc.tagBg || RARITY_COLORS[nick.rarity] || accent;
        cx.font = '8px "Press Start 2P"';
        cx.fillText(nick.label, nx, 121);
    }

    // Bio
    if (S.profileData.bio && S.profileData.bio.trim()) {
        cx.fillStyle = midText;
        cx.font = '700 12px Nunito, sans-serif';
        _wrapText(cx, S.profileData.bio, nx, 140, 432, 16, 2);
    }

    // Traits
    if (S.profileData.traits && S.profileData.traits.length) {
        const tc = ['#e91e8c', '#f72585', '#f5c842', '#7dd3fc'];
        cx.fillStyle = isDark ? '#aaa' : '#bbb';
        cx.font = '6px "Press Start 2P"';
        cx.fillText('TRAITS', nx, 178);
        S.profileData.traits.forEach((t, i) => {
            const bx = nx + i * 113;
            cx.fillStyle = tc[i] || accent;
            cx.font = '7px "Press Start 2P"';
            cx.fillText('◆', bx, 195);
            cx.fillStyle = bodyText;
            cx.fillText(t.slice(0, 9).toUpperCase(), bx + 14, 195);
        });
    }

    // Dashed divider
    cx.strokeStyle = accentDiv;
    cx.lineWidth = 1;
    cx.setLineDash([5, 5]);
    cx.beginPath();
    cx.moveTo(20, 218);
    cx.lineTo(W - 20, 218);
    cx.stroke();
    cx.setLineDash([]);

    // Alien count + pts
    cx.fillStyle = bodyText;
    cx.font = '7px "Press Start 2P"';
    cx.textAlign = 'left';
    cx.fillText(`👾 ${S.myAliens.length} ALIEN${S.myAliens.length !== 1 ? 'S' : ''}`, 24, 240);
    cx.fillStyle = accent;
    cx.fillText(`✦ ${S.pts} PTS`, 290, 240);

    // Draw up to 8 alien images
    let drawn = 0;
    for (const a of S.myAliens.slice(0, 8)) {
        try {
            const al = ALIENS[a.alienId];
            if (!al) continue;
            const img = await _loadImg(al.img);
            cx.drawImage(img, 24 + drawn * 62, 250, 54, 54);
            drawn++;
        } catch {
        }
    }
    if (!drawn) {
        cx.fillStyle = isDark ? '#888' : '#ccc';
        cx.font = '10px "Press Start 2P"';
        cx.textAlign = 'center';
        cx.fillText('no aliens yet... pull the gacha! 🎰', W / 2, 280);
        cx.textAlign = 'left';
    }

    // IRL rewards
    const irl = S.ownedIrl || [];
    if (irl.length > 0) {
        cx.textAlign = 'left';
        cx.fillStyle = isDark ? '#999' : '#bbb';
        cx.font = '6px "Press Start 2P"';
        cx.fillText('IRL REWARDS', 24, 321);
        cx.fillStyle = accent;
        cx.font = '700 12px Nunito, sans-serif';
        const names = irl.map(i => (i.icon || '🎟') + ' ' + i.name).join('  ·  ');
        cx.fillText(names.slice(0, 72), 24, 338);
    }

    // Secret ending — DOCUMENTED archive stamp (lower-right corner)
    if (S.mailEnding === 'documented') {
        const sx = W - 168, sy = 310, sw = 148, sh = 40;
        cx.fillStyle = '#2d1a08';
        cx.fillRect(sx + 2, sy + 3, sw, sh);
        cx.fillStyle = '#f4e4c1';
        cx.fillRect(sx, sy, sw, sh);
        cx.strokeStyle = '#2d1a08';
        cx.lineWidth = 2.5;
        cx.strokeRect(sx, sy, sw, sh);
        cx.fillStyle = '#a8865c';
        cx.fillRect(sx + 5, sy + 5, 30, sh - 10);
        cx.strokeStyle = '#5d4023';
        cx.lineWidth = 1.5;
        cx.strokeRect(sx + 5, sy + 5, 30, sh - 10);
        cx.fillStyle = '#f4e4c1';
        cx.font = '5px "Press Start 2P"';
        cx.textAlign = 'center';
        cx.fillText('✦ ✦', sx + 20, sy + 16);
        cx.fillText('STAFF', sx + 20, sy + 25);
        cx.fillText('✦ ✦', sx + 20, sy + 34);
        cx.textAlign = 'left';
        cx.fillStyle = '#2d1a08';
        cx.font = '6px "Press Start 2P"';
        cx.fillText('SECRET ENDING', sx + 42, sy + 14);
        cx.fillStyle = '#6b4423';
        cx.font = '5px "Press Start 2P"';
        cx.fillText('DOKOMI ARCHIVE', sx + 42, sy + 24);
        cx.fillText('with E.MORROW', sx + 42, sy + 33);
    }

    // Bottom footer
    cx.fillStyle = accent;
    cx.fillRect(0, H - 50, W, 50);
    cx.fillStyle = '#1a0010';
    cx.fillRect(0, H - 50, W, 2);

    // Random funny tagline
    const tags = [
        `i have ${S.myAliens.length} aliens and zero regrets 🎰`,
        `spent all my pts on the gachapon... totally worth it`,
        `officially a konbini regular 🥲`,
        `do NOT check how many times i pulled the lever`,
        `my alien ${S.myAliens[0] ? S.myAliens[0].name : 'buddy'} says hi 👾`,
        `yes these are my real traits 💅`,
        `the aliens are my family now`,
        `i came for the gacha, i stayed for the vibes`,
    ];
    const tag = tags[Math.floor(Math.random() * tags.length)];

    cx.fillStyle = accentText;
    cx.textAlign = 'center';
    cx.font = '8px "Press Start 2P"';
    cx.fillText('clowri-konbini.com', W / 2, H - 28);
    cx.fillStyle = accentTextFaint;
    cx.font = '700 11px Nunito, sans-serif';
    cx.fillText(tag, W / 2, H - 10);

    // Slight border on whole card
    cx.strokeStyle = 'rgba(26,0,16,.15)';
    cx.lineWidth = 2;
    cx.strokeRect(1, 1, W - 2, H - 2);

    cv.toBlob(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `konbini-${(S.profileData.name || 'user').toLowerCase()}-card.png`;
        a.click();
        URL.revokeObjectURL(url);
        toast('Card saved! Share the konbini love ✦ 📤');
        if (window.triggerMission) window.triggerMission('profile_png_save');
    }, 'image/png');
}

function updateProfileDisplay() {
    const hc = S.profileData.headerColors || {};
    // Apply accent colour as CSS variable on the whole window
    const win = document.getElementById('w-profile');
    if (win) {
        if (hc.tagBg) {
            win.style.setProperty('--prof-accent', hc.tagBg);
            win.style.setProperty('--prof-accent-text', _isLightAccent(hc.tagBg) ? '#1a0010' : '#fff');
        } else {
            win.style.removeProperty('--prof-accent');
            win.style.removeProperty('--prof-accent-text');
        }
    }
    // Name
    const _nm = document.getElementById('prof-name-display');
    if (_nm) {
        _nm.innerHTML = '';
        const _nt = document.createElement('span');
        _nt.textContent = S.profileData.name || 'USER';
        _nm.appendChild(_nt);
        if (S.data_early_adopter_flag) {
            const _tmp = document.createElement('span');
            _tmp.innerHTML = earlyBadgeHTML(22);
            _nm.appendChild(_tmp.firstChild);
        }
        _nm.style.color = hc.nameFill || '';
        _nm.style.webkitTextStroke = hc.nameStroke ? `3px ${hc.nameStroke}` : '';
    }
    // Status — small "vibe" line. CSS hides .prof-status:empty so the
    // area collapses cleanly when nothing is set.
    const statusEl = document.getElementById('prof-status-display');
    if (statusEl) statusEl.textContent = S.profileData.status || '';
    // Avatar
    const av = document.getElementById('prof-av-img');
    if (av) av.src = `assets/profile/profile_icon${window.profIconIdx}.png`;
    // Subnick / tag — rarity class drives the pill color unless user has overridden it
    const nick = ALL_NICKS.find(n => n.id === S.profileData.nick);
    const tagEl = document.getElementById('prof-tag-display');
    tagEl.textContent = nick ? nick.label : '';
    tagEl.className = 'prof-tag' + (nick ? ` prof-tag--${nick.rarity}` : '');
    tagEl.style.background = hc.tagBg || '';
    tagEl.style.color = hc.tagBg ? (_isLightAccent(hc.tagBg) ? '#1a0010' : '#fff') : '';
    // Header background (headerBg can be a gradient so stays as its own override)
    const profTop = document.querySelector('#w-profile .prof-top');
    if (profTop) profTop.style.background = hc.headerBg || '';
    // Bio
    document.getElementById('prof-bio-display').innerHTML =
        (S.profileData.bio || '<span style="color:#bbb;font-style:italic;">No bio yet — click ✎ EDIT PROFILE!</span>').replace(/\n/g, '<br>');
    // Traits — show grid if set, hide and show hint if not
    const traitsWrap = document.getElementById('prof-traits-wrap');
    if (S.profileData.traits && S.profileData.traits.length === 4) {
        traitsWrap.style.display = '';
        ['trait1', 'trait2', 'trait3', 'trait4'].forEach((id, i) => {
            const el = document.getElementById(id);
            if (el) el.textContent = S.profileData.traits[i];
        });
    } else {
        traitsWrap.style.display = 'none';
    }
    // Aliens
    const box = document.getElementById('prof-aliens-display');
    if (S.myAliens.length === 0) {
        box.textContent = '?';
    } else {
        box.innerHTML = S.myAliens.slice(0, 4).map(a => {
            const al = ALIENS[a.alienId];
            return al ? `<img src="${al.img}" style="height:42px;object-fit:contain;">` : '';
        }).join('');
    }
    // IRL rewards
    const irlWrap = document.getElementById('prof-irl-wrap');
    const irlBox = document.getElementById('prof-irl-display');
    if (irlWrap && irlBox) {
        if (S.ownedIrl && S.ownedIrl.length > 0) {
            irlWrap.style.display = '';
            irlBox.innerHTML = S.ownedIrl.map(item =>
                `<div class="prof-irl-item">${item.icon || '🎟'} ${item.name}</div>`
            ).join('');
        } else {
            irlWrap.style.display = 'none';
        }
    }
    // Secret ending — DOCUMENTED unlock (staff archive print, redeemable at booth)
    const secret = document.getElementById('inv-rewards');
    if (secret) {
        if (S.mailEnding === 'documented') {
            secret.innerHTML = `
                <div class="prof-secret-print">
                    <div class="psp-tape psp-tape--tl"></div>
                    <div class="psp-tape psp-tape--tr"></div>
                    <div class="psp-photo">
                        <div class="psp-photo-grain"></div>
                        <div class="psp-photo-inner">
                            <div class="psp-photo-row">✦ &nbsp; ✦ &nbsp; ✦ &nbsp; ✦</div>
                            <div class="psp-photo-title">DOKOMI</div>
                            <div class="psp-photo-sub">STAFF ARCHIVE</div>
                            <div class="psp-photo-row psp-photo-row--bottom">— with E.MORROW —</div>
                        </div>
                    </div>
                    <div class="psp-caption">
                        <div class="psp-caption-pill">✦ SECRET ENDING UNLOCKED</div>
                        <div class="psp-caption-body">A hand-printed copy of the old staff photo with E.Morrow. Redeem in person at booth 3X09 ✦</div>
                    </div>
                </div>`;
        } else {
            secret.innerHTML = '<div class="inv-empty">No rewards yet! Visit the shop ✦</div>';
        }
    }
}

// ── Edit-profile UI helpers (tabs, search, live preview) ────────────

function _epSetTab(name) {
    document.querySelectorAll('.ep-tab').forEach(t => t.classList.toggle('on', t.dataset.pane === name));
    document.querySelectorAll('.ep-pane').forEach(p => p.classList.toggle('on', p.dataset.pane === name));
}

function _epFilterNicks(q) {
    const query = (q || '').trim().toLowerCase();
    document.querySelectorAll('#nick-list .nick-chip').forEach(chip => {
        const txt = chip.textContent.toLowerCase();
        chip.style.display = (!query || txt.includes(query)) ? '' : 'none';
    });
}

// Cosmetic sub-labels for trait cards in the redesigned modal — same
// vibe as the reference design's "tidy worker" / "people lover" style.
const _TRAIT_SUBS = {
    organized: 'tidy worker', creative: 'arty mind',
    practical: 'gets it done', dreamy: 'soft soul',
    outgoing: 'people lover', shy: 'quiet kind',
    realistic: 'grounded vibes', idealistic: 'dreamer',
};

function _epRenderTraitCards() {
    const cont = document.getElementById('edit-traits-preview');
    if (!cont) return;
    const traits = S.profileData.traits;
    if (!traits || traits.length === 0) {
        cont.innerHTML = '<div class="ep-traits-empty">No traits yet — take the test!</div>';
        return;
    }
    cont.innerHTML = traits.map(t => {
        const sub = _TRAIT_SUBS[String(t).toLowerCase()] || '';
        return `<div class="ep-trait-card"><div class="v">${t}</div><div class="l">${sub}</div></div>`;
    }).join('');
}

// Refresh the live-preview card from the current modal state.
// No-op when the redesigned modal isn't on screen yet.
function _epUpdatePreview() {
    const card = document.querySelector('#edit-modal .ep-preview-card');
    if (!card) return;

    const nameInput = document.getElementById('edit-name');
    const name = ((nameInput && nameInput.value) || S.profileData.name || 'CLOWRI').toUpperCase().slice(0, 12);
    document.getElementById('ep-prev-name').textContent = '@' + name;

    const bioInput = document.getElementById('edit-bio');
    const bio = (bioInput && bioInput.value) || S.profileData.bio || '...';
    document.getElementById('ep-prev-bio').textContent = bio;
    const counter = document.getElementById('edit-bio-counter');
    if (counter) counter.textContent = (bioInput ? bioInput.value.length : 0) + '/120';

    const statusInput = document.getElementById('edit-status');
    const status = (statusInput && statusInput.value) || S.profileData.status || '';
    const statusEl = document.getElementById('ep-prev-status');
    if (statusEl) statusEl.textContent = status ? '· ' + status : '';

    const idx = window.profIconIdx || 1;
    const img = document.getElementById('ep-prev-img');
    if (img) img.src = `assets/profile/profile_icon${idx}.png`;

    const sel = document.querySelector('#nick-list .nick-chip.sel');
    const tagEl = document.getElementById('ep-prev-tag');
    const eqRow = document.getElementById('edit-eq-row');
    if (sel && sel.dataset.id) {
        const nick = ALL_NICKS.find(n => n.id === sel.dataset.id);
        const label = nick ? nick.label : sel.textContent.replace(/^\+\s*/, '');
        if (tagEl) { tagEl.textContent = '+ ' + label; tagEl.style.display = 'inline-block'; }
        if (eqRow) {
            eqRow.innerHTML = '';
            const chip = document.createElement('span');
            chip.className = 'ep-eq-chip';
            chip.textContent = '× ' + label;
            chip.title = 'Click to unequip';
            chip.addEventListener('click', () => {
                document.querySelectorAll('.nick-chip').forEach(c => c.classList.remove('sel'));
                _epUpdatePreview();
            });
            eqRow.appendChild(chip);
        }
    } else {
        if (tagEl) { tagEl.textContent = '+ Worker'; tagEl.style.display = 'inline-block'; }
        if (eqRow) eqRow.innerHTML = '<span class="ep-eq-empty">no title equipped</span>';
    }

    // Header colors — reuse pending colors so unsaved swatches preview live.
    const banner = document.getElementById('ep-prev-banner');
    const hc = _pendingColors || S.profileData.headerColors || {};
    if (banner) banner.style.background = hc.headerBg || 'linear-gradient(110deg,#fff8f0,#ffdcec)';
    const prevName = document.getElementById('ep-prev-name');
    if (prevName) {
        prevName.style.color = hc.nameFill || '';
        prevName.style.webkitTextStroke = hc.nameStroke ? '1px ' + hc.nameStroke : '';
    }
    if (tagEl) tagEl.style.background = hc.tagBg || '';
}

function openEditModal() {
    document.getElementById('edit-name').value = S.profileData.name;
    document.getElementById('edit-bio').value = S.profileData.bio;
    document.getElementById('edit-status').value = S.profileData.status || '';
    updateNickList();
    _epRenderTraitCards();
    const hc = S.profileData.headerColors || {};
    _pendingColors = {nameFill: hc.nameFill || '', nameStroke: hc.nameStroke || '', tagBg: hc.tagBg || '', headerBg: hc.headerBg || ''};
    _buildColorRow('swatch-nameFill', _PALETTE_NAME_FILL, _pendingColors.nameFill, 'nameFill');
    _buildColorRow('swatch-nameStroke', _PALETTE_NAME_STROKE, _pendingColors.nameStroke, 'nameStroke');
    _buildColorRow('swatch-tagBg', _PALETTE_TAG_BG, _pendingColors.tagBg, 'tagBg');
    _buildColorRow('swatch-headerBg', _PALETTE_HEADER_BG, _pendingColors.headerBg, 'headerBg');
    renderInvIcons('edit-icon-grid');

    // Always re-open on the Identity tab so the user lands somewhere
    // predictable rather than wherever they last left it.
    _epSetTab('identity');

    // Wire (idempotent — assigning to .oninput replaces any prior handler).
    document.querySelectorAll('.ep-tab').forEach(t => {
        t.onclick = () => _epSetTab(t.dataset.pane);
    });
    const nameIn   = document.getElementById('edit-name');
    const bioIn    = document.getElementById('edit-bio');
    const statusIn = document.getElementById('edit-status');
    const search   = document.getElementById('edit-nick-search');
    if (nameIn)   nameIn.oninput   = _epUpdatePreview;
    if (bioIn)    bioIn.oninput    = _epUpdatePreview;
    if (statusIn) statusIn.oninput = _epUpdatePreview;
    if (search) {
        search.value = '';
        search.oninput = e => _epFilterNicks(e.target.value);
    }

    _epUpdatePreview();

    const m = document.getElementById('edit-modal');
    m.style.display = 'flex';
    m.style.alignItems = 'center';
    m.style.justifyContent = 'center';
}

function closeEditModal() {
    _pendingColors = null;
    document.getElementById('edit-modal').style.display = 'none';
}

function saveProfile() {
    S.profileData.name = document.getElementById('edit-name').value.trim().toUpperCase().slice(0, 12) || S.profileData.name;
    S.profileData.bio = document.getElementById('edit-bio').value.trim() || S.profileData.bio;
    // Status accepts blank (intentional clear) and is capped at 24 to
    // match the input's maxlength so the column never gets overrun.
    S.profileData.status = document.getElementById('edit-status').value.trim().slice(0, 24);
    // Honour explicit unequip: when the user has clicked the selected
    // chip off, persist the cleared title instead of silently keeping
    // the previous one.
    const sel = document.querySelector('.nick-chip.sel');
    S.profileData.nick = sel ? sel.dataset.id : '';
    if (_pendingColors) S.profileData.headerColors = {..._pendingColors};
    _pendingColors = null;
    closeEditModal();
    updateProfileDisplay();
    toast('Profile saved! ♡');
    scheduleSave();
    if (window.triggerMission) window.triggerMission('edit_profile');
}

function updateNickList() {
    const cont = document.getElementById('nick-list');
    cont.innerHTML = '';
    ALL_NICKS.forEach(n => {
        const isUnlocked = S.unlockedNicks.includes(n.id);
        const chip = document.createElement('div');
        chip.className = 'nick-chip' + (S.profileData.nick === n.id ? ' sel' : '') + (isUnlocked ? '' : ' locked');
        chip.dataset.id = n.id;
        chip.textContent = isUnlocked ? '+ ' + n.label : '🔒 ' + n.label;
        chip.title = isUnlocked ? 'Click to select' : ('Unlock: ' + (n.how || '???'));
        if (isUnlocked) chip.addEventListener('click', () => {
            const wasSelected = chip.classList.contains('sel');
            document.querySelectorAll('.nick-chip').forEach(c => c.classList.remove('sel'));
            // Click on the already-selected chip unequips it (matches the
            // equipped-row chip's "click to remove" affordance).
            if (!wasSelected) chip.classList.add('sel');
            _epUpdatePreview();
        });
        cont.appendChild(chip);
    });
}

function unlockNick(id) {
    if (!S.unlockedNicks.includes(id)) {
        S.unlockedNicks.push(id);
        const n = ALL_NICKS.find(x => x.id === id);
        if (n) {
            toast(`New subnick unlocked: ${n.label} 🎉`);
            SFX.play('unlock');
        }
        updateNickList();
        scheduleSave();
        _recordUnlockRemote('nick', id);
    }
}

function unlockBg(value) {
    if (!S.unlockedBgs.includes(value)) {
        S.unlockedBgs.push(value);
        scheduleSave();
        _recordUnlockRemote('bg', value);
    }
}

function _recordUnlockRemote(type, key) {
    if (!window.DB || !window.DB.available()) return;
    window.DB.getSession().then(({data: {session}}) => {
        if (session) window.DB.recordUnlock(session.user.id, type, key);
    }).catch(() => {});
}

// ── Trait test ─────────────────────────────
function openTraitTest() {
    closeEditModal();
    S.traitAnswers = [];
    S.traitQIdx = 0;
    // Shuffle questions and shuffle each question's options independently
    S.shuffledTraitQs = TRAIT_QS.map(q => ({...q, opts: [...q.opts].sort(() => Math.random() - .5)}))
        .sort(() => Math.random() - .5);
    document.getElementById('trait-result').style.display = 'none';
    document.getElementById('trait-opts').innerHTML = '';
    showTraitQ();
    openWin('w-trait');
}

function showTraitQ() {
    const q = S.shuffledTraitQs[S.traitQIdx];
    document.getElementById('trait-progress').textContent = `QUESTION ${S.traitQIdx + 1}/4`;
    document.getElementById('trait-question').textContent = q.q;
    const opts = document.getElementById('trait-opts');
    opts.innerHTML = '';
    q.opts.forEach(([label, trait]) => {
        const btn = document.createElement('div');
        btn.className = 'trait-opt';
        btn.textContent = label;
        btn.addEventListener('click', () => {
            S.traitAnswers.push(trait);
            S.traitQIdx++;
            if (S.traitQIdx < TRAIT_QS.length) showTraitQ(); else showTraitResult();
        });
        opts.appendChild(btn);
    });
}

function showTraitResult() {
    document.getElementById('trait-opts').innerHTML = '';
    document.getElementById('trait-progress').textContent = 'RESULTS!';
    document.getElementById('trait-question').textContent = '';
    const result = document.getElementById('trait-result');
    result.style.display = 'block';
    const colors = ['color:#e91e8c', 'color:#f72585', 'color:#f5c842', 'color:#7dd3fc'];
    document.getElementById('trait-result-card').innerHTML = S.traitAnswers.map((t, i) => `<div class="trait-ri" style="${colors[i]}">◆ ${t}</div>`).join('');
}

function closeTraitTest() {
    S.profileData.traits = [...S.traitAnswers];
    closeWin('w-trait');
    // openEditModal repopulates everything (including the trait cards
    // via _epRenderTraitCards), so no need to set the preview here.
    openEditModal();
    toast('Traits saved! ✦');
}

window.renderInvIcons = renderInvIcons;
window.setProfileIcon = setProfileIcon;
window.updateProfileDisplay = updateProfileDisplay;
window.openEditModal = openEditModal;
window.closeEditModal = closeEditModal;
window.saveProfile = saveProfile;
window.saveProfilePNG = saveProfilePNG;
window.updateNickList = updateNickList;
window.unlockNick = unlockNick;
window.unlockBg = unlockBg;
window.openTraitTest = openTraitTest;
window.showTraitQ = showTraitQ;
window.showTraitResult = showTraitResult;
window.closeTraitTest = closeTraitTest;
